import { Button, Divider, Grid } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';

import { messages } from './PopupFooter.messages';
import { PopupFooterProps } from './PopupFooter.types';

export const PopupFooter: FC<PopupFooterProps> = memo((props) => {
    const { withBackButton, isLoading, onBack, onSkip } = props;

    return (
        <Grid gap={24} width='100%'>
            {withBackButton && <Divider color='midnight40' />}

            <Grid
                gap={16}
                gridTemplateColumns='repeat(auto-fit, minmax(0, auto))'
                justifyContent={withBackButton ? 'space-between' : 'end'}
            >
                <Button variant='text' color='blue100' size='small' noPadding disabled={isLoading} onClick={onSkip}>
                    {messages.skip}
                </Button>

                {withBackButton && (
                    <Button variant='text' color='blue100' size='small' noPadding disabled={isLoading} onClick={onBack}>
                        {messages.back}
                    </Button>
                )}
            </Grid>
        </Grid>
    );
});

PopupFooter.displayName = 'PopupFooter';
